import React from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  CircularProgress,
  CardMedia,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { getAllData } from "../libs/firebase/firestore/getAllData";
import { deleteData } from "../libs/firebase/firestore/deleteData";
import { useEffect } from "react";
import { useNavigateToTop } from "../libs/useNavigateToTop";
import AppBarHome from "../components/AppBar/Home";

import SiteTemplateImage from "../images/siteTemplate.jpeg";
import AppBarSites from "../components/AppBar/Sites";
import { DeleteForever } from "@mui/icons-material";
import theme from "../components/theme/theme";

const Sites = ({}) => {
  const [loading, setLoading] = React.useState(true);
  const [sites, setSites] = React.useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [siteToDelete, setSiteToDelete] = React.useState(null);
  const navigate = useNavigateToTop();

  const handleSiteClick = (clientUid) => {
    console.log("clientUid", clientUid);
    navigate(`/site/${clientUid}`);
  };

  useEffect(() => {
    // get the resource lists from firebase
    handleSitesUpdated();

    // get the materials from firebase
  }, []);

  const handleSitesUpdated = () => {
    // get the resource lists from firebase
    getAllData("/sites").then((data) => {
      setSites(data);
      setLoading(false);
    });
  };

  const handleDeleteSite = () => {
    if (siteToDelete) {
      deleteData(
        `/sites`,
        siteToDelete.storageDocumentId,
        () => {
          handleSitesUpdated();
          setDeleteDialogOpen(false);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  };

  const handleOpenDeleteDialog = (site) => {
    setSiteToDelete(site);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <Box>
      <AppBarSites onUpdated={handleSitesUpdated} />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        <Grid container spacing={2}>
          {/* loader */}
          {loading && (
            <Box
              style={{
                textAlign: "center",
                margin: "2rem 0rem",
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {sites.map((site, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardActionArea
                  onClick={() => handleSiteClick(site.storageDocumentId)}
                >
                  {/* Delete icon button top right */}
                  <IconButton
                    aria-label="delete"
                    style={{ position: "absolute", top: "0", right: "0" }}
                    variant="contained"
                    color="secondary"
                    onClick={(event) => {
                      // prevent bubbling up to the card
                      event.stopPropagation();
                      handleOpenDeleteDialog(site);
                    }}
                  >
                    <DeleteForever />
                  </IconButton>
                  <CardMedia
                    component="img"
                    height="140"
                    image={site.siteProfilePicture || SiteTemplateImage}
                    alt={site.clientName}
                  />
                  <CardContent
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                    }}
                  >
                    <Typography variant="h6">{site.clientName}</Typography>
                    <Typography variant="body2">{site.address}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Delete dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to delete this site?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} autoFocus>
            Cancel
          </Button>
          <Button onClick={handleDeleteSite}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Sites;
